import React from "react"
import { Button } from "@chakra-ui/react"
import { useConfigContext } from "@app/providers/config"

import type { SelectedOptionProps } from "@root/types/global"
import { SelectableOption } from "@app/components/Product/Form/ProductFormTypes"

type Props = {
  handleOption: (option: { name: string; value: string }) => void
  selectableOptions: SelectableOption[]
  selectedOptions: Array<SelectedOptionProps>
}

export const ProductGiftCardDenominations: React.FC<Props> = ({ handleOption, selectedOptions, selectableOptions }) => {
  const {
    settings: {
      product: { giftCardDenomination },
    },
  } = useConfigContext()

  const selectedOptionValue = selectedOptions.find(option => option.name === giftCardDenomination)?.value
  return (
    <>
      {selectableOptions
        .find(option => option.name === giftCardDenomination)
        ?.values.map(({ value }) => {
          const isActive = selectedOptionValue === value
          return (
            <Button
              variant="variantSelector"
              lineHeight={1}
              key={`${value}`}
              fontSize={14}
              fontWeight={isActive ? "bold" : "normal"}
              borderWidth={isActive ? "2px" : "2px"}
              borderColor={isActive ? "grey.coal" : "grey.fog"}
              bg="white"
              color="grey.coal"
              minWidth={["66px", "75px", "85px"]}
              onClick={() => {
                handleOption({ name: giftCardDenomination, value })
              }}
            >
              {value}
            </Button>
          )
        })}
    </>
  )
}
